exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ba-common-globaltoastcontainer{z-index:9898;position:fixed;width:288px}", ""]);

// exports
exports.locals = {
	"globalToastContainerClassName": "\"ba-common-globaltoastcontainer\""
};